export default __webpack_public_path__ + "static/media/logo.16eb2aa3.png";